const topbarUsps = [...document.querySelectorAll('.js-topbar-usp')];

if(topbarUsps.length > 1) {
    let current = 0;

    const interval = setInterval(() => {
        topbarUsps[current].removeAttribute('data-current');

        current++;

        if(current > topbarUsps.length - 1) {
            current = 0;
        }

        topbarUsps[current].setAttribute('data-current', '');
    }, 5000);
}
